import React, { Component } from "react";
import { fetchAccountEligibility } from "./accountEligibilityApi";
import { eligibilitySummaryRows } from "./accountEligibility";
import "./AccountEligibilitySection.css";

export const LOCKED_NOTE =
  "To protect account and eligibility information, these details cannot be changed directly. Please contact support if a correction is needed.";

export const INCOMPLETE_NOTE =
  "Some details are still missing. You will be asked to add them the next time you open the app.";

/**
 * Read-only "Account Eligibility" row on the subscriber Account page. Values
 * come from the owner-only eligibility status endpoint. There is no edit
 * control here: missing details are entered only through AccountCompletionGate.
 */
class AccountEligibilitySection extends Component {
  state = { status: null };

  componentDidMount() {
    this._mounted = true;
    fetchAccountEligibility()
      .then((status) => {
        if (this._mounted) {
          this.setState({ status });
        }
      })
      .catch(() => {});
  }

  componentWillUnmount() {
    this._mounted = false;
  }

  render() {
    const { status } = this.state;
    const rows = eligibilitySummaryRows(status);
    if (!rows) {
      return null;
    }

    return (
      <div className="account-sec account-eligibility-sec">
        <div className="row">
          <div className="col-12 col-sm-3 col-md-3 col-lg-3 col-xl-3">
            <h4 className="account-sec-head">Account Eligibility</h4>
          </div>
          <div className="col-12 col-sm-5 col-md-5 col-lg-5 col-xl-5">
            {rows.map((row) => (
              <div className="account-eligibility-row" key={row.key}>
                <span className="account-eligibility-label">{row.label}</span>
                <h5
                  className={
                    "email account-eligibility-value" +
                    (row.value ? "" : " account-eligibility-missing")
                  }
                >
                  {row.value || "Not provided"}
                </h5>
              </div>
            ))}
          </div>
          <div className="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
            {status.complete === true ? null : (
              <p className="account-eligibility-note">{INCOMPLETE_NOTE}</p>
            )}
            <p className="account-eligibility-note">{LOCKED_NOTE}</p>
          </div>
        </div>
      </div>
    );
  }
}

export default AccountEligibilitySection;
